import React from 'react';
import type PlanSettingsPermissionsType from '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-settings/permissions/index.tsx';
import { markAsProductBundleReady } from '@atlassian/jira-spa/src/services/mark-as-product-bundle-ready/index.tsx';
import { LazyPage } from '@atlassian/jira-spa/src/view/lazy-page/index.tsx';
import { lazyForPaint } from '@atlassian/react-loosely-lazy';

/**
 * Plan Settings - permissions page
 */
// eslint-disable-next-line jira/deprecations/no-rll-client-async-experiences
export const LazyPlanSettingsPermissions = lazyForPaint<typeof PlanSettingsPermissionsType>(
	() =>
		markAsProductBundleReady(
			import(
				/* webpackChunkName: "async-plan-settings-permissions", jiraSpaEntry: "async-plan-settings-permissions" */ '@atlassian/jira-spa-apps-advanced-roadmaps-plan/src/ui/plan-settings/permissions'
			),
		),
	{ ssr: false },
);

// eslint-disable-next-line jira/import/no-anonymous-default-export
export default () => (
	<LazyPage
		Page={LazyPlanSettingsPermissions}
		pageId="plan-settings-permissions"
		shouldShowSpinner
	/>
);
